import VideoSlides from './VideoSlides';

export default VideoSlides;
